import { useAuth } from '@clerk/clerk-react';
import { useQuery } from '@tanstack/react-query';
import { AdminApiError } from '../../api/admin-client.js';
import { fetchAdminTaxRates } from '../api/catalog-api.js';

export function useAdminTaxRates() {
  const { isLoaded, isSignedIn, getToken } = useAuth();
  return useQuery({
    queryKey: ['admin', 'catalog', 'tax-rates'],
    queryFn: async ({ signal }) => {
      const token = await getToken();
      if (!token) {
        throw new AdminApiError('AUTHENTICATION_ERROR', 'Your session has expired. Please sign in again.', 401);
      }
      return fetchAdminTaxRates({ token, signal });
    },
    enabled: isLoaded && isSignedIn === true,
    staleTime: 60_000,
  });
}
